const Ranking = () => {
  return (
    <div>
      <h1>Proximamente, Rankings!</h1>
    </div>
  );
}
export default Ranking;